module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07415_banner_800x600.3eb990d7.png";